import React from 'react';
import config from '@config';
import { useStore } from '@hooks';
import { Button, Icon } from '@ui';
import { Flex } from 'antd';

export const OAuthButtons = ({ method, btnText }) => {
    const store = useStore();

    return (
        <Flex gap={16} vertical>
            {config.isGoogleOauthEnabled ? (
                <Button onClick={() => store.authStore.platformOauthRedirect('google', method)}>
                    <Flex gap={8} justify='center' align='center'>
                        <Icon.GoogleIcon style={{ width: '24px', height: '24px' }} />
                        {btnText} with Google
                    </Flex>
                </Button>
            ) : null}
            {config.isMicrosoftOauthEnabled ? (
                <Button onClick={() => store.authStore.platformOauthRedirect('microsoft', method)}>
                    <Flex gap={8} justify='center' align='center'>
                        <Icon.MicrosoftIcon /> {btnText} with Microsoft
                    </Flex>
                </Button>
            ) : null}
        </Flex>
    );
};
